import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Form } from '/imports/ui/Form';
import { FormField } from '/imports/ui/FormField';
import { Input } from '/imports/ui/Input';
import { accountUsername, updateAccountCredentials } from '/imports/api/accounts';

interface AccountCredentialsProps {
  accountId: string;
  onSuccess?(): void;
}

export const AccountCredentials = (props: AccountCredentialsProps) => {
  const accountId = props.accountId;
  const [username, setUsername] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [error, setError] = useState<any>();
  useEffect(() => {
    (async () => setUsername(await accountUsername.call(accountId)))();
  }, []);
  const updateCredentials = async () => {
    try {
      await updateAccountCredentials.call({ accountId, credentials: { username, password } });
      props.onSuccess?.();
    }
    catch (error: any) {
      if (error?.reason === 'validationError') {
        const details = JSON.parse(error.details);
        setError(details);
      }
      else {
        toast.error(strings.AnErrorOccurredPleaseTryAgainOrContactSupport());
      }
    }
  };
  return (
    <div>
      <Form onSubmit={() => updateCredentials()}>
        <div className="field-group">
          <FormField field="username" error={error}>
            <label>{strings.Username()}</label>
            <Input
              value={username}
              onChange={(username) => setUsername(username)}
            />
          </FormField>
          <FormField field="password" error={error}>
            <label>{strings.Password()}</label>
            <Input
              type="password"
              value={password}
              onChange={(password) => setPassword(password)}
            />
          </FormField>
          <div className={`update-button flex flex-col ${error ? 'justify-center' : 'justify-end'}`}>
            <Button type="submit">{strings.Update()}</Button>
          </div>
        </div>
      </Form>
    </div>
  );
};